import React, { useEffect, useMemo, useState } from 'react';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import cx from 'classnames';
import { isEmpty } from 'lodash';
import moment from 'moment';

import Button from '../../../../../../../common/general/Button';
import useOutsideClickDetector from '../../../../../../../common/hooks/useOutsideClickDetector';
import { DD_SLASH_MMM_SLASH_YYYY } from '../../../../../../../constants/dateFormat';

import '../WorklistTableHeaderFilter.scss';

export function WorklistFinanceCompleteFilter({ filterRef, isFilterVisible, setFilterVisible, Context }) {
  const { tableData, financeCompleteDate, setFinanceCompleteDate, currentlySelected } = Context;

  const [placedOnTop, setPlacedOnTop] = useState(false);
  const [selectedFinanceCompleteDate, setSelectedFinanceCompleteDate] = useState(financeCompleteDate);
  const dialogRef = React.useRef();

  useOutsideClickDetector(filterRef, event => {
    if (dialogRef.current && dialogRef.current.contains(event.target)) {
      return;
    }
    setFilterVisible(false);
  });

  useEffect(
    function() {
      setPlacedOnTop(tableData.length < 4);
    },
    [tableData.length]
  );

  useEffect(() => {
    if (currentlySelected) {
      isEmpty(financeCompleteDate) && setSelectedFinanceCompleteDate(financeCompleteDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentlySelected]);

  const financeCompleteDatePickerValue = useMemo(() => {
    const financeCompleteDatePickerValue = selectedFinanceCompleteDate
      ? moment(selectedFinanceCompleteDate, 'YYYY-MM-DD', true)
      : null;
    return financeCompleteDatePickerValue && financeCompleteDatePickerValue.isValid()
      ? financeCompleteDatePickerValue
      : null;
  }, [selectedFinanceCompleteDate]);

  return (
    <>
      {isFilterVisible && (
        <div
          className={cx('filter-dropdown', placedOnTop ? 'placed-on-top' : 'placed-on-bottom', 'date-filter')}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <DesktopDatePicker
            label="Finance Complete Date"
            value={financeCompleteDatePickerValue}
            onChange={function(date) {
              setSelectedFinanceCompleteDate(date && date.isValid() ? date.format('YYYY-MM-DD') : null);
            }}
            format={DD_SLASH_MMM_SLASH_YYYY}
            views={['year', 'month', 'day']}
            localeText={{
              fieldMonthPlaceholder: () => 'MMM'
            }}
            slotProps={{
              textField: {
                variant: 'outlined',
                fullWidth: true
              },
              popper: {
                ref: dialogRef
              }
            }}
          />
          <div className={'filter-footer date-filter'}>
            <Button
              priority="medium"
              onClick={() => {
                setSelectedFinanceCompleteDate(null);
              }}
              disabled={!selectedFinanceCompleteDate}
            >
              Clear
            </Button>
            <Button
              priority="high"
              onClick={() => {
                setFinanceCompleteDate(selectedFinanceCompleteDate);
                setFilterVisible(false);
              }}
              disabled={selectedFinanceCompleteDate === financeCompleteDate}
            >
              Apply
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
